import { Button, Collapse, Icon } from "@blueprintjs/core";
import React, { useState } from "react";

type ErrorsMap = Record<string, string>;

interface ErrorsCollapseProps {
  errors: ErrorsMap;
  title?: string;
}

const ErrorsCollapse: React.FC<ErrorsCollapseProps> = ({
  errors,
  title = "Validation errors",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const entries = Object.entries(errors);

  if (entries.length === 0) return null;

  return (
    <section className="mb-4 rounded-xl border border-red-200 bg-red-50/70 p-3">
      <button
        className="flex w-full cursor-pointer items-center justify-between gap-3 text-left"
        onClick={() => setIsOpen((current) => !current)}
        type="button"
      >
        <span className="flex min-w-0 items-center gap-2">
          <Icon icon="warning-sign" intent="danger" />
          <span className="truncate text-sm font-bold text-red-800">
            {title} ({entries.length})
          </span>
        </span>

        <Button
          minimal
          icon={isOpen ? "chevron-up" : "chevron-down"}
          onClick={(event) => {
            event.stopPropagation();
            setIsOpen((current) => !current);
          }}
        />
      </button>

      <Collapse isOpen={isOpen}>
        <div className="mt-3 space-y-2 rounded-lg border border-red-200 bg-white/70 p-3">
          {entries.map(([field, message]) => (
            <div
              className="grid gap-1 text-sm text-red-800 md:grid-cols-[minmax(0,0.45fr)_minmax(0,1fr)]"
              key={field}
            >
              <span className="font-bold">{field}</span>
              <span className="font-medium">{message}</span>
            </div>
          ))}
        </div>
      </Collapse>
    </section>
  );
};

export default ErrorsCollapse;
